import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=c9ce5106&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=c9ce5106&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ce5106",
  null
  
)

export default component.exports